export { default } from './DestacatButlleti';
